import UserService from '../services/UserService';
import { User } from '../models';
import store from '@/store';

export interface UserState {
  users: User[];
}

export const UserModule = {
  state: {
    users: null,
  },
  mutations: {
    setUsers(state: any, users: User[]) {
      state.users = users;
    },
  },
  actions: {
    async loadUsers({commit}: any) {
      if (!store.state.user.users) {
        const users = await UserService.getAllUsers();
        commit('setUsers', users);
      }
    },
  },
};
